import {FieldArray, FormikValues} from 'formik'
import React from 'react'
import type {IAgencyBase, ICompanyBase} from '~/src/models'
import createAddressItem from '../../components/platform/onboarding/helpers/createAddress'
import CompanyAddressSignInItem from './AddressFieldSignInItem'
import {Button} from '~/src/design-system/Primitives'

interface IProps {
  values?: FormikValues
  activePlatform: string
  setFieldValue: (field: string, value: unknown) => void
  initialEditValues?: IAgencyBase | ICompanyBase | undefined
}

export default function CompanyAddressSignInList(props: IProps) {
  const {addresses} = props.values ?? {}

  return (
    <FieldArray name="addresses">
      {({push, remove}) => (
        <React.Fragment>
          {addresses.length > 0 &&
            addresses.map((address: {id: string}, index: number) => (
              <CompanyAddressSignInItem
                key={address.id}
                addresses={addresses}
                initialEditValues={props.initialEditValues}
                index={index}
                remove={remove}
                setFieldValue={props.setFieldValue}
                activePlatform={props.activePlatform}
              />
            ))}

          {/** DS-layout: use Stack/Grid from ~/src/design-system for new layout code */}
          <div>
            <Button
              variant="tertiary"
              size="sm"
              sx={{color: 'primary.dark', p: 0, mt: 4}}
              onClick={() => push(createAddressItem())}>
              + Add Another Location
            </Button>
          </div>
        </React.Fragment>
      )}
    </FieldArray>
  )
}
